import type { FaireProductEntity } from "../../entity_types/product";

export const p_4rqpzuym3v: FaireProductEntity = {
  token: "p_4rqpzuym3v",
  type: "product",
  name: "Colon Detox & Cleanse - Digestive Health",
  brandToken: "b_5071j6eb6g",
  brandName: "NutraChamps",
  imageUrl:
    "https://cdn.faire.com/fastly/7039996314942a8f1598c5458363c86ee93ab1828c20737bb51a3ab57884926a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e3dcc4c8cf164e81bb6b267f5da38968c1b7600adc6841c1828b5186641b9392.jpeg",
    "https://cdn.faire.com/fastly/c2e22afc694e807e763363798c85961ae7f6f5797028b1c28cf4345ecb80bdac.jpeg",
    "https://cdn.faire.com/fastly/1f6a5d5e201b06341a9c114903db212b1c0ff3d8f45601ea8dfc41e8f902c760.jpeg",
    "https://cdn.faire.com/fastly/98348576edeac6fd6f9cf0f40aa247f73f9f22228e8a18cf7680f83a86fd6829.jpeg",
    "https://cdn.faire.com/fastly/f4b5b4c01f70d5e7eda83b6c855c1d054b36d6f0acd64a3b608a0f7596ab73b5.jpeg",
    "https://cdn.faire.com/fastly/0dc2581cb7d6a190ee82c4da4769b93009d529c2ea7b3488fce0ccaa3e78d89e.jpeg",
  ],
  priceDollars: 12.43,
  description:
    "NutraChamps Colon Detox & Cleanse is the perfect supplement to cleanse out your intestinal tract of excess waste and kick-start any weight loss program. Loaded with nature’s most effective colon cleansing and digestive detoxifiers, Colon Detox & Cleanse delivers a gentle, deep cleanse that will leave you feeling lighter, refreshed and rejuvenated.",
  tags: [],
  msrpDollars: 20.72,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:17.664Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
